import { getIsV3 } from './utils';

const DEFAULT_STRUCTURE_JSON_V1_FORMAT = 'application/vnd.sdmx.structure+json;version=1.0';
const DEFAULT_STRUCTURE_JSON_V2_FORMAT = 'application/vnd.sdmx.structure+json;version=2.0';
const DEFAULT_DATA_JSON_V1_FORMAT = 'application/vnd.sdmx.data+json;version=1.0.0-wd';
const DEFAULT_DATA_CSV_V1_FORMAT = 'application/vnd.sdmx.data+csv';
const DEFAULT_DATA_JSON_V3_FORMAT = 'application/vnd.sdmx.data+json;version=2.0';
const DEFAULT_DATA_CSV_V3_FORMAT = 'application/vnd.sdmx.data+csv;version=2.0';

const injectParam = param => headerFormat =>
  headerFormat.includes(param) ? headerFormat : `${headerFormat};${param}`;
const injectUrn = injectParam('urn=true');
const injectFile = injectParam('file=true');

export const getStructureV1HeaderFormat = datasource =>
  injectUrn(datasource?.headers?.structure?.json || DEFAULT_STRUCTURE_JSON_V1_FORMAT);

const getStructureV2HeaderFormat = datasource =>
  injectUrn(datasource?.headers?.structure?.json || DEFAULT_STRUCTURE_JSON_V2_FORMAT);

export const getDataV1HeaderFormat = (datasource, format = 'json') => {
  switch (format) {
    case 'csv':
      return injectFile(datasource?.headers?.data?.csv || DEFAULT_DATA_CSV_V1_FORMAT);
    case 'json':
    default:
      return injectUrn(datasource?.headers?.data?.json || DEFAULT_DATA_JSON_V1_FORMAT);
  }
};

export const getStructureHeaderFormat = datasource => {
  if (getIsV3(datasource)) {
    return getStructureV2HeaderFormat(datasource);
  }
  return getStructureV1HeaderFormat(datasource);
};

export const getMetadataHeaderFormat = (datasource, format = 'json') => {
  switch (format) {
    case 'csv':
      return injectFile(datasource?.headersv3?.metadata?.csv || DEFAULT_DATA_CSV_V3_FORMAT);
    case 'json':
    default:
      return injectUrn(datasource?.headersv3?.metadata?.json || DEFAULT_DATA_JSON_V3_FORMAT);
  }
};
